import { JwtAxios } from '@/packaging';

// 업로드마켓 알리익스프레스(AliExpress) — 수집몰 알리익스프레스(AliExpress-KR)와는 별개 설정이다.
export const aliExpressApi = {
  // POST /api/Template/Market/SetAliExpressApi
  // payload: { marketAccount(판매자 식별자), key1(App Key), key2(App Secret), key3(Access Token), key4(Refresh Token), key6(인증코드) }
  async SetAliExpressApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetAliExpressApi', body);
    return responseModel;
  },
  async GetAliExpressApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetAliExpressApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetAliExpressApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetAliExpressApiTemplate`, model);
    return responseModel;
  },
  // 판매자센터에 등록된 배송비/서비스 템플릿 목록
  async GetAliExpressTemplates(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetAliExpressTemplates?marketAccount=${marketAccount}`
    );
    return responseModel;
  }
};
